export default "__VITE_ASSET__058ae730__"